import { render } from "./sectionTitle.vue?vue&type=template&id=c0d8a32e&scoped=true"
import script from "./sectionTitle.vue?vue&type=script&lang=js"
export * from "./sectionTitle.vue?vue&type=script&lang=js"

import "./sectionTitle.vue?vue&type=style&index=0&id=c0d8a32e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jerry\\桌面\\HTML\\罣礙網站\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d8a32e"]])

export default __exports__